import { signin, signout, getUserInfo, refreshAccessToken } from '@/api'

const accessToken = localStorage.getItem('accessToken')
const refreshToken = localStorage.getItem('refreshToken')

export default {
  namespaced: true,
  state: {
    info: {
      id: -1,
      username: '',
      isAdmin: false
    },
    isLoggedIn: false,
    accessToken,
    refreshToken
  },
  mutations: {
    setAuthorization (state, { accessToken, refreshToken }) {
      if (accessToken) {
        localStorage.setItem('accessToken', accessToken)
        state.accessToken = accessToken
      }

      if (refreshToken) {
        localStorage.setItem('refreshToken', refreshToken)
        state.refreshToken = refreshToken
      }
    },
    setInfo (state, user) {
      if (!user) return
      state.isLoggedIn = true
      state.info = Object.assign({}, state.info, user)
    }
  },
  actions: {
    async signin ({ commit }, { username, password }) {
      const { accessToken, refreshToken } = await signin(username, password)
      commit('setAuthorization', { accessToken, refreshToken })
    },
    async signout () {
      await signout()
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('accessToken')
    },
    async initialize ({ commit }) {
      const user = await getUserInfo()
      if (user) commit('setInfo', user)
    },
    async refreshAccessToken ({ state, commit }) {
      const { accessToken } = await refreshAccessToken(state.refreshToken)
      if (accessToken) commit('setAuthorization', { accessToken })
    }
  },
  getters: {
    isAdmin (state) {
      return state.info.isAdmin
    }
  }
}
